export const ngxExtendedPdfViewerAssetsPath = 'https://cdn.jsdelivr.net/npm/ngx-extended-pdf-viewer@21.4.4/assets';

export const pwaHardcodedNgxExtendedPdfViewerUrls: Array<string> = [
    ngxExtendedPdfViewerAssetsPath +'/locale/locale.json',
    ngxExtendedPdfViewerAssetsPath +'/locale/en-US/viewer.ftl',
    ngxExtendedPdfViewerAssetsPath +'/viewer-4.6.688.min.mjs',
    ngxExtendedPdfViewerAssetsPath +'/pdf.worker-4.6.688.min.mjs',
    '/assets/appsettings.json'
]


